<template>
  <section class="ui-comment row">
    <div
      class="ui-comment__avatar col-md-auto text-center mb-4 mb-sm-0"
      v-if="avatar || $slots.avatar"
    >
      <slot name="avatar">
        <img :src="avatar">
      </slot>
    </div>
    <div class="col">
      <div class="ui-comment__header">
        <header class="ui-comment-header text-center text-sm-left">
          <slot name="time">
            <time
              class="ui-comment-header__time"
              :datetime="created"
            >
              {{ formattedDate }}
            </time>
          </slot>
          <slot name="username">
            <div class="ui-comment-header__username">
              {{ name }}<span class="ml-2" v-if="link"><a :href="link" target="_blank" rel="nofollow">{{ linkText }}</a></span>
            </div>
          </slot>
        </header>
      </div>
      <div class="ui-comment__body">
        <slot>{{ content }}</slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UiComment',

  props: {
    avatar: String,
    name: String,
    content: String,
    created: String,
    link: String,
  },

  computed: {
    linkText() {
      if (this.link) {
        const url = new URL(this.link)
        return url.hostname
      }
      return null
    },

    formattedDate() {
      const date = new Date(this.created);
      return date.toLocaleDateString('ru-RU', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
  }
}
</script>

<style>
  .ui-comment__header {
    margin-bottom: 10px;
  }
  .ui-comment-header__time {
    color: #999;
    font-size: .75rem;
  }
  .ui-comment-header__username {
    font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    font-weight: bold;
  }

  .ui-comment__body {
    white-space: pre-wrap;
  }
</style>
